export default __webpack_public_path__ + "static/grey-background-504cf9ff44c902d71a08926168a11b44.png";